import request from '@/utils/request-report';

// 社区 事件上报
export async function reportCommunityEvent(data: any) {
  return request({
    method: 'POST',
    url: '/sdksq_api/data/report',
    data,
  });
}